// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".deposit-widget[data-v-a6e7eed2] {\n  background: var(--magic-tertiary, #311261);\n  box-shadow: none;\n}\n\n.text[data-v-a6e7eed2] {\n  font-weight: var(--magic-font-weight-bold, 700);\n  color: var(--magic-light, #fff);\n}\n\n.button[data-v-a6e7eed2] {\n  --magic-primary: #fd0;\n  --button-primary-darker: #fd0;\n}", ""]);
// Exports
module.exports = exports;
